// LTV-2794
// temporary hack for the costco test  to check if a user is on a costco plan without Backend work
// after the test, this should be removed and backend should be updated
export var COSTCO_PLAN_IDS = [19256, 19262, 19263, 19264, 19265, 19266, 19267, 19268, 19269, 19270, 19271, 19272, 19280, 19281, 19282, 19326, 19325, 19324];